import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router";
import { toast, Zoom } from "react-toastify";
import {
  CreateOrgPageList,
  Edit_OrgPageList,
  FILE_API,
  PageClone,
} from "../api/Organization Api/OrganizationApi";
import PersonalPageContext from "../context/PersonalPageContext/PersonalPageContaxt";
import ProfileComponentContext from "../context/ProfilecomponentContext/ProfilecomponetContext";
import { classes } from "../data/layouts";
import Breadcrumbs from "../layout/breadcrumb";
import { FILE_TYPE, QR_THEME_COLORS, TYPES } from "../constant";
import TopLoadingBar from "../utils/topLoadingBar";
import PageItemContext from "../context/PageItemContext/PageItmContext";
import ProfileComponentItem from "./ProfileComponentItem";
import LoaderContext from "../context/LoaderContext/LoaderContext";
import { isEmpty } from "../utils/helper";
import SimpleReactValidator from "simple-react-validator";
import { uploadFileToSpaces } from "../components ByteCard/apis/dashboardAPi/DeshboardApi";

const ProfileComponent = () => {
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const {
    email,
    setEmail,
    fname,
    setFname,
    lname,
    setLname,
    pagetitle,
    setPageTitle,
    orgName,
    setOrgName,
    designation,
    setDesignation,
    address,
    setAddress,
    conuntry,
    setConuntry,
    state,
    setState,
    city,
    setCity,
    logo,
    setLogo,
    theme,
    color,
    dialCode,
    setDialCode,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    userEmail,
    setUserEmail,
    mobile,
    setMobile,
    seoTitle,
    setSeoTitle,
    seoDescription,
    setSeoDescription,
    seoKey,
    setSeoKey,
    slugUrl,
    isDialog,
    isFource,
    isLabel,
    setIsDialog,
    isBranchLabel,
    isShowBranch,
    setIsFource,
    setIsLabel,
    setIsShowBranch,
    setIsBranchLabel,

    editIndex,
    setIsAddHandle,
    check,
    setCheck,
    data,
    setData,
    userPhoto,
    setUserPhoto,
    pageThemeConfigColors,
    setPageThemeConfigColors,
  } = useContext(ProfileComponentContext);
  const {
    togglesubmit,
    orgPageList,
    progress,
    setProgress,
    clone,
    setClone,
    setToggle,
  } = useContext(PersonalPageContext);
  const { loaderShow, setLoaderShow } = useContext(LoaderContext);
  const { pageUuid } = useContext(PageItemContext);
  const defaultLayoutObj = classes.find(
    (item) => Object.values(item).pop(1) === "compact-wrapper"
  );
  const layout =
    localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();
  const history = useNavigate();
  let { hwId } = useParams();
  const [baseUrl, setBaseUrl] = useState("");

  /**
   *organization logo add
   */

  const readUrl = async (event, type) => {
    if (event.target.files.length === 0) return;
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      if (type === "company") {
        setLogo(reader.result);
      } else if (type === "user") {
        setUserPhoto(reader.result);
      }
    };

    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.ORGANIZATION_LOGO);
    // formData.append("file", event.target.files[0]);
    const uniqueName = `${Date.now()}-${event.target.files[0].name}`;
    const formData = {
      type: FILE_TYPE.ORGANIZATION_LOGO,
      file: uniqueName,
      fileType: event.target.files[0].type,
    }
    try {
      const { data } = await FILE_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          toast.error("Failed to get upload URL", {
            autoClose: 1000,
            transition: Zoom,
          });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, event.target.files[0]);
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom,
        });
        if (type === "company") {
          setLogo(data.payload.imageUrl);
        } else if (type === "user") {
          setUserPhoto(data.payload.imageUrl);
        }
        setBaseUrl(data.payload.baseUrl);
      } else {
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  /**
   * onSubmit() function to use of organization add,clone and edit to use
   */

  const onSubmit = async (e) => {
    e.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      if (editIndex > -1 && togglesubmit) {
        setLoaderShow(!loaderShow);
        let logoUrl =
          logo &&
          logo?.split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER}/`).pop();
        let userLogoUrl =
          userPhoto &&
          userPhoto?.split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER}/`).pop();
        let formData = isEmpty({
          seoTitle: seoTitle,
          seoKeyword: seoKey,
          seoDesc: seoDescription,
          mobile,
          userEmail,
          email,
          fname,
          lname,
          pageTitle: pagetitle,
          orgName,
          designation,
          address,
          country: conuntry,
          state,
          city,
          dialCode,
          slugUrl,
          // blockerSlugUrl,
          templateId: data.value ? data.value : data[0].value,
          orgLogo: logoUrl,
          userPhoto: userLogoUrl,
          pageThemeConfig: {
            // themeColor: theme ? theme : "#3e3088",
            // fontColor: color ? color : "#FFFFFF",
            // theme5: {
            //   themeColor: "red",
            //   fontColor: "white",
            // },
            ...(pageThemeConfigColors || QR_THEME_COLORS),
          },
          type: TYPES.LANDING_PAGE,
          config: {
            isDialog,
            isFource,
            isLabel,
            branch_label: isBranchLabel,
            is_show_branch: isShowBranch,
          },
        });
        try {
          const { data } = await Edit_OrgPageList(formData, pageUuid);
          if (data.status === 200) {
            toast.success(data.message, {
              autoClose: 1000,
            });
            emptyFeild();
            history(`/${hwId}/PersonalPage/PersonalPage/${layout}`);
          } else {
          }
        } catch (error) {
          setLoaderShow(false);
          toast.error(error.response.data.message, {
            autoClose: 1000,
            transition: Zoom,
          });
        }
      } else if (clone === false) {
        let logoUrl =
          logo &&
          logo.split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER}/`).pop();
        let userLogoUrl =
          userPhoto &&
          userPhoto?.split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER}/`).pop();
        setLoaderShow(!loaderShow);
        let formData = isEmpty({
          pageUuid,
          seoTitle: seoTitle,
          seoKeyword: seoKey,
          seoDesc: seoDescription,
          mobile,
          userEmail,
          password,
          confirmPassword,
          email,
          fname,
          lname,
          pageTitle: pagetitle,
          orgName,
          designation,
          address,
          country: conuntry,
          state,
          city,
          dialCode,
          slugUrl,
          // blockerSlugUrl,
          templateId: data.value ? data.value : data[0].value,
          orgLogo: logoUrl,
          userPhoto: userLogoUrl,
          pageThemeConfig: {
            ...QR_THEME_COLORS,
          },
          isUserCreate: check,
          type: TYPES.LANDING_PAGE,
          config: {
            isDialog,
            isFource,
            isLabel,
            branch_label: isBranchLabel,
            is_show_branch: isShowBranch,
          },
        });

        try {
          const { data } = await PageClone(formData);
          if (data.status === 200) {
            await orgPageList();
            toast.success(data.message, {
              autoClose: 1000,
              transition: Zoom,
            });
            emptyFeild();
            history(`/${hwId}/PersonalPage/PersonalPage/${layout}`);
          } else {
          }
        } catch (error) {
          setLoaderShow(false);
          toast.error(error.response.data.message, {
            autoClose: 1000,
            transition: Zoom,
          });
        }
      } else {
        setLoaderShow(!loaderShow);
        let formData = isEmpty({
          seoTitle: seoTitle,
          seoKeyword: seoKey,
          seoDesc: seoDescription,
          mobile,
          userEmail,
          password,
          confirmPassword,
          email,
          fname,
          lname,
          pageTitle: pagetitle,
          orgName,
          designation,
          address,
          country: conuntry,
          state,
          city,
          dialCode,
          templateId: data.value ? data.value : data[0].value,
          orgLogo: logo,
          slugUrl,
          userPhoto,
          // blockerSlugUrl,
          pageThemeConfig: {
            themeColor: "#3e3088",
            fontColor: "#FFFFFF",
            theme5: {
              themeColor: "red",
              fontColor: "white",
            },
          },
          isUserCreate: check,
          type: TYPES.LANDING_PAGE,
          config: {
            isDialog,
            isFource,
            isLabel,
            branch_label: isBranchLabel,
            is_show_branch: isShowBranch,
          },
        });
        try {
          const { data } = await CreateOrgPageList(formData);
          if (data.status === 200) {
            await orgPageList();

            toast.success(data.message, {
              autoClose: 1000,
              transition: Zoom,
            });
            emptyFeild();
            history(`/${hwId}/PersonalPage/PersonalPage/${layout}`);
          } else {
          }
        } catch (error) {
          setLoaderShow(false);
          toast.error(error.response.data.message, {
            autoClose: 1000,
            transition: Zoom,
          });
        }
      }
    }
  };

  /**
   * click to Pervius button to go to back be used to Privius() function
   */

  const emptyFeild = () => {
    setIsAddHandle(true);
    setClone(true);
    setToggle(false);
    setCheck(true);
    setData([]);
    setMobile(null);
    setUserEmail(null);
    setEmail(null);
    setFname(null);
    setLname(null);
    setPageTitle(null);
    setOrgName(null);
    setDesignation(null);
    setAddress(null);
    setConuntry(null);
    setState(null);
    setCity(null);
    setSeoDescription(null);
    setSeoKey(null);
    setSeoTitle(null);
    setLogo(null);
    setUserPhoto(null);
    setPassword(null);
    setConfirmPassword(null);
    setDialCode("+91");
    setData([]);
    setLoaderShow(false);
    setIsDialog(false);
    setIsFource(false);
    setIsLabel("");
    setIsShowBranch(false);
    setIsBranchLabel("");
    setPageThemeConfigColors({});
  };

  const Previus = () => {
    emptyFeild();
    history(`/${hwId}/PersonalPage/PersonalPage/${layout}`);
  };

  /**
   * useEffect to use of topLoading call
   */

  useEffect(() => {
    setProgress(100);
  }, []);

  const onCheck = () => {
    setCheck(!check);
  };

  return (
    <>
      <Fragment>
        <Breadcrumbs parent="Profile Page" />
        <TopLoadingBar progress={progress} setProgress={setProgress} />
        <ProfileComponentItem
          onCheck={onCheck}
          readUrl={readUrl}
          baseUrl={baseUrl}
          onSubmit={onSubmit}
          Previus={Previus}
          simpleValidator={simpleValidator}
        />
      </Fragment>
    </>
  );
};

export default ProfileComponent;
